// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// http://adsperience.stas.dev.ergonized.com/api/ https://api.adxcms.com/api/

export const environment = {
  production: false,
  apiUrl: 'https://adsperience2.stas.dev.ergonized.net/api/',
  altApiUrl: 'https://adsperience2.stas.dev.ergonized.net/api/',
  apiKey: '38b593f0afda0f071f8d184bcf172089e9090823',
  /**
   * Exclude adding param filters[websiteId]
   */
  websiteBlackList: [
    'users',
    'websites',
    'dealers',
    'coupons',
    'coupon/search',
    'userroles',
    'permissions',
    'makes',
    'make/search',
    'models',
    'model/search',
    'statistics',
    'user/search',
    'dealer/search',
    'website/search'
    /*'files',*/
  ]
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts